/**
 * The different types of results available
 */
export enum ResultTypes {
    ASSESSMENT = "assessment",
    ASSESSMENT_DUE_WORK = "assessment.dueWork",
    ASSESSMENT_LESSON_PLAN = "assessment.lessonPlan",
    ASSESSMENT_PROJECT = "assessment.project",
    ASSESSMENT_LTI = "assessment.lti",
    ASSESSMENT_TASK = "assessment.task",
    ASSESSMENT_QUIZ = "assessment.quiz",
    ASSESSMENT_DIALOG_AGENT = "assessment.dialogAgent",
    BADGE = "badge",
    BLOG = "blog",
    EVENT = "event",
    FILE = "file",
    FILE_AUDIO = "file.audio",
    FILE_DOCUMENT = "file.document",
    FILE_IMAGE = "file.image",
    FILE_VIDEO = "file.video",
    FILE_OTHER = "file.other",
    FORUM = "forum",
    LINK = "link",
    NEWS = "news",
    PAGE = "page",
    PAGE_CLASS = "page.class",
    PAGE_COURSE = "page.course",
    PAGE_HOMEPAGE = "page.homepage",
    PAGE_UNIT = "page.unit",
    PAGE_FOLDER = "page.folder",
    PAGE_GROUP = "page.group",
    TEXTBOX = "textbox",
    TILE = "tile",
    USER = "user",
    USER_GUEST = "user.guest",
    USER_PARENT = "user.parent",
    USER_STAFF = "user.staff",
    USER_STUDENT = "user.student",
}
